import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const PRICING_MODES = ['global', 'categories', 'items', 'daily'];

export default function ExportPricingModeSwitcher({ mode, onChange }) {
  const { t } = useTranslation('trips');
  const [open, setOpen] = useState(false);

  const label = (id) => t(`export.preview.pricingMode.${id}.label`);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="export-hidden fixed bottom-4 left-4 z-popover rounded-md border border-k-gray bg-white px-3 py-2 text-2xs font-semibold uppercase tracking-widest text-[var(--td-ink)] shadow-sm"
      >
        {t('export.preview.pricingMode.pill')} · {label(mode)}
      </button>
    );
  }

  return (
    <div className="export-hidden fixed bottom-4 left-4 z-popover w-64 rounded-md border border-k-gray bg-white p-3 shadow-md">
      <div className="flex items-center justify-between">
        <div className="text-2xs font-semibold uppercase tracking-widest text-[var(--td-primary)]">
          {t('export.preview.pricingMode.title')}
        </div>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label={t('export.preview.pricingMode.close')}
          className="appearance-none bg-transparent border-0 p-0 m-0 outline-none cursor-pointer text-[var(--td-ink-muted)] leading-none"
        >
          ✕
        </button>
      </div>

      <div className="mt-3 space-y-2">
        {PRICING_MODES.map((id) => (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={`block w-full rounded-md border px-3 py-2 text-left ${
              id === mode
                ? 'border-[var(--td-primary)] bg-[var(--td-primary-soft)]'
                : 'border-k-gray/60 bg-white'
            }`}
          >
            <div className="text-sm font-medium text-[var(--td-ink)]">
              {label(id)}
            </div>
            <div className="text-2xs text-[var(--td-ink-muted)]">
              {t(`export.preview.pricingMode.${id}.hint`)}
            </div>
          </button>
        ))}
      </div>

      <div className="mt-3 text-2xs italic text-[var(--td-ink-muted)]">
        {t('export.preview.pricingMode.note')}
      </div>
    </div>
  );
}
